import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Problem } from '@xmedical/core';

// Pure dialog content — collects a problem name and returns it via
// dialogRef.close(). The opener (problem-widget) runs the persist with
// ProblemListRepositoryService.
@Component({
  selector: 'xcs-problem-item-add-card',
  templateUrl: './problem-item-add-card.component.html',
  styleUrls: ['./problem-item-add-card.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class ProblemItemAddCardComponent implements OnInit {

  private dialogRef = inject<MatDialogRef<ProblemItemAddCardComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  protected data = inject<{ searchTerm?: string } | null>(MAT_DIALOG_DATA, { optional: true });

  validate = false;
  form: UntypedFormGroup | null = null;

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      problem: [this.data?.searchTerm || '', Validators.required],
    });
  }

  save(): void {
    if (!this.form) return;
    if (this.form.valid) {
      this.dialogRef.close(this.form.value as Problem);
    }
    this.validate = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
